import React, { createContext, useContext, useState, useEffect, useCallback, useRef } from 'react';
import { useAuth } from './AuthContext';
import { bountyService } from '../api/services';

const BountyCountContext = createContext({ totalCount: 0, mineCount: 0 });

// 懸賞計數 Context：輪詢全站有效案件數與目前使用者領取中數量，供導覽列/側欄徽章共用
export const BountyCountProvider = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const [totalCount, setTotalCount] = useState(0);
  const [mineCount, setMineCount] = useState(0);
  const intervalRef = useRef(null);

  const refresh = useCallback(async () => {
    if (!isAuthenticated) return;
    try {
      const res = await bountyService.counts();
      setTotalCount(res.data?.total || 0);
      setMineCount(res.data?.mine || 0);
    } catch { /* 靜默失敗，不影響主流程 */ }
  }, [isAuthenticated]);

  useEffect(() => {
    if (!isAuthenticated) {
      setTotalCount(0);
      setMineCount(0);
      return undefined;
    }
    refresh();
    // 15 秒輪詢一次，與結案/領取彈跳卡片同節奏，讓導覽列/側欄/懸賞榜的計數數字接近即時更新
    intervalRef.current = setInterval(refresh, 15000);
    return () => clearInterval(intervalRef.current);
  }, [isAuthenticated, refresh]);

  return (
    <BountyCountContext.Provider value={{ totalCount, mineCount, refresh }}>
      {children}
    </BountyCountContext.Provider>
  );
};

export const useBountyCount = () => useContext(BountyCountContext);
